import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  margin-top: 70px;
  background: #fbfbfb;

  @media (max-width: 800px) {
    margin-top: 56px;
  }
`

export const Section = styled.section`
  width: min(1540px, calc(100% - 48px));
  margin: 0 auto;
  padding: 42px 0 0;

  @media (max-width: 800px) {
    width: min(100% - 24px, 720px);
    padding-top: 28px;
  }
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 18px;
`

export const SectionIntro = styled.div`
  h1,
  h2 {
    margin: 0;
    color: #262626;
    font-size: 31px;
    line-height: 1.05;
    font-weight: 750;
  }

  h1 strong,
  h2 strong {
    color: #e50000;
    font-weight: 750;
  }

  p {
    margin: 7px 0 0;
    color: #777;
    font-size: 14px;
  }

  @media (max-width: 800px) {
    h1,
    h2 {
      font-size: 24px;
    }
  }
`

export const SectionLink = styled.button`
  border: 0;
  background: transparent;
  color: #e50000;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 640px) {
    display: none;
  }
`

export const FeaturedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;

  @media (max-width: 1120px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`

export const ItineraryCard = styled.article`
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #ededed;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.055);
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 34px rgba(0, 0, 0, 0.09);
  }
`

export const ItineraryCover = styled.img`
  display: block;
  width: 100%;
  aspect-ratio: 16 / 7.6;
  object-fit: cover;
  background: #f1f1f1;
`

export const ItineraryInfo = styled.div`
  padding: 14px 16px 15px;
`

export const ItineraryTitle = styled.h3`
  min-height: 44px;
  margin: 0 0 9px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #202020;
  font-size: 15px;
  line-height: 1.42;
  font-weight: 750;
`

export const RatingLine = styled.div`
  min-height: 22px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #777;
  font-size: 12px;

  svg {
    color: #ffb400;
    font-size: 14px;
  }

  strong {
    color: #454545;
  }
`

export const ItineraryMeta = styled.div`
  display: flex;
  gap: 18px;
  margin-top: 11px;
  padding-top: 11px;
  border-top: 1px solid #eee;
  color: #717171;
  font-size: 12px;

  span {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  svg {
    color: #e50000;
    font-size: 11px;
  }
`

export const CommunityCard = styled.div`
  min-height: 180px;
  display: grid;
  grid-template-columns: 1.1fr auto 1fr;
  align-items: center;
  gap: 34px;
  padding: 28px 34px;
  border-radius: 24px;
  background: linear-gradient(110deg, #fff 0%, #fff 63%, #fff7f4 100%);
  border: 1px solid #ececec;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.05);

  @media (max-width: 1020px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`

export const CommunityCopy = styled.div`
  h1,
  h2 {
    margin: 0;
    color: #282828;
    font-size: 28px;
  }

  h1 strong,
  h2 strong {
    color: #e50000;
  }

  p {
    margin: 7px 0 18px;
    color: #777;
    font-size: 14px;
  }
`

export const AvatarStack = styled.div`
  display: flex;
  align-items: center;
`

export const Avatar = styled.img`
  width: 46px;
  height: 46px;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid #fff;
  margin-left: -8px;

  &:first-child {
    margin-left: 0;
  }
`

export const AvatarMore = styled.div`
  width: 46px;
  height: 46px;
  margin-left: -8px;
  border-radius: 50%;
  border: 3px solid #fff;
  background: #f1f1f1;
  color: #555;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 700;
`

export const CommunityStats = styled.div`
  display: flex;
  align-items: stretch;
  gap: 18px;

  @media (max-width: 560px) {
    justify-content: space-between;
    gap: 10px;
  }
`

export const Stat = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 92px;

  > svg {
    color: #e50000;
    font-size: 24px;
  }

  > div {
    display: flex;
    flex-direction: column;
  }

  strong {
    color: #242424;
    font-size: 21px;
    line-height: 1;
  }

  span {
    margin-top: 4px;
    color: #777;
    font-size: 11px;
  }
`

export const StatDivider = styled.div`
  width: 1px;
  background: #e8e8e8;
`

export const CommunityActions = styled.div`
  padding-left: 28px;
  border-left: 1px solid #e8e8e8;

  > span {
    display: block;
    max-width: 280px;
    margin-bottom: 17px;
    color: #484848;
    font-size: 15px;
    line-height: 1.45;
  }

  > div {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  @media (max-width: 1020px) {
    padding-left: 0;
    border-left: 0;
  }
`

export const PrimaryButton = styled.button`
  height: 42px;
  padding: 0 21px;
  border: 0;
  border-radius: 12px;
  background: #e50000;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(229, 0, 0, 0.16);
`

export const OutlineButton = styled.button`
  height: 42px;
  padding: 0 21px;
  border: 1px solid #e50000;
  border-radius: 12px;
  background: #fff;
  color: #e50000;
  font-weight: 700;
  cursor: pointer;
`

export const DestinationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr 1fr;
  }
`

export const DestinationCard = styled.button<{ $image: string }>`
  position: relative;
  min-height: 148px;
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  padding: 15px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
  text-align: left;
  background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.62),
      rgba(0, 0, 0, 0.02) 70%
    ),
    url('${({ $image }) => $image}');
  background-size: cover;
  background-position: center;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`

export const DestinationName = styled.span`
  color: #fff;
  font-size: 17px;
  font-weight: 750;
  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.35);
`

export const DestinationCount = styled.span`
  padding: 5px 9px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  background: rgba(30, 30, 30, 0.28);
  backdrop-filter: blur(6px);
  color: #fff;
  font-size: 10px;
  white-space: nowrap;
`

export const AffiliateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 1050px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 580px) {
    grid-template-columns: 1fr;
  }
`

export const AffiliateCard = styled.button`
  min-height: 84px;
  display: grid;
  grid-template-columns: 46px 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 12px 15px;
  border: 1px solid #ececec;
  border-radius: 16px;
  background: #fff;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.035);

  > div {
    width: 46px;
    height: 46px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: #fff1f1;
    color: #e50000;
    font-size: 20px;
  }

  > span {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  strong {
    color: #303030;
    font-size: 13px;
  }

  small {
    color: #777;
    font-size: 10px;
    line-height: 1.35;
  }

  > b {
    color: #8b8b8b;
    font-size: 23px;
    font-weight: 400;
  }

  &:hover {
    border-color: #e5b6b6;
  }
`

export const CtaBanner = styled.div`
  min-height: 110px;
  margin-bottom: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 34px;
  border-radius: 22px;
  border: 1px solid #f0d9d9;
  background: linear-gradient(100deg, #fff6f4 0%, #f9ded8 100%);

  @media (max-width: 700px) {
    align-items: flex-start;
    flex-direction: column;
  }
`

export const CtaCopy = styled.div`
  h1,
  h2 {
    margin: 0;
    color: #2d2d2d;
    font-size: 28px;
  }

  h1 strong,
  h2 strong {
    color: #e50000;
  }

  p {
    margin: 6px 0 0;
    color: #696969;
    font-size: 13px;
  }
`

export const CtaButton = styled.button`
  height: 48px;
  padding: 0 26px;
  border: 0;
  border-radius: 13px;
  background: #e50000;
  color: #fff;
  font-size: 14px;
  font-weight: 750;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 10px 20px rgba(229, 0, 0, 0.18);
`
